class BaseModule {
  constructor($el, options) {
    this.$el = $el
    this.$spread = this.$el.closest('.js__spread')

    this.subModules = []

    this.preInit(options)

    if (this.isMother) {
      this.gatherChildren()
      this.gatherAsideChildren()
    }

    this.$spread.on('spreadCreated', (e, spread) => {
      this.spread = spread
      this.onSpreadCreated()
      this.postInit()

      if (this.unloadable) {
        this.spread.$el.on('spreadLoaded', () => {
          if (this.isLoaded) return
          this.load()
          this.isLoaded = true
        })

        this.spread.$el.on('spreadUnloaded', () => {
          this.unload()
          this.isLoaded = false
        })
      }
    })
  }

  gatherChildren() {
    this.$el.on('moduleInit', (e, subModule) => {
      e.stopPropagation()
      this.subModules.push(subModule)
    })
  }

  onSpreadCreated() {
    if (this.isAffectingHeight) {
      this.spread.affectingModules.push(this)
    } else if (this.isFinal) {
      this.spread.finalModules.push(this)
    } else {
      this.register()
    }
  }

  register() {
    this.$el.parent().trigger('moduleInit', this)
  }

  reset() {
    this.preReset()

    this.subModules.forEach(function(subModule) {
      subModule.reset()
    })

    this.postReset()
  }

  calculate() {
    this.preCalculate()

    this.subModules.forEach(function(subModule) {
      subModule.calculate()
    })

    this.postCalculate()
  }

  render() {
    this.preRender()

    this.subModules.forEach(function(subModule) {
      subModule.render()
    })

    this.postRender()
  }

  preInit() {}
  postInit() {}
  preReset() {}
  postReset() {}
  preRender() {}
  postRender() {}
  preCalculate() {}
  postCalculate() {}
  gatherAsideChildren() {}
  load() {}
  unload() {}
}

module.exports = BaseModule
